import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { isRTL } from "../../utils";

export default function LiveTasks() {
	const tasks = useSelector((state) => state.webSocket.tasks);
	console.log("Tasks", tasks);
	useEffect(() => {
		if (tasks) {
			toast.info(
				<div>
					<div>{tasks?.name}</div>
					<div>{!isRTL ? tasks.changeMessageEN : tasks.changeMessageAR} </div>
				</div>,
				{
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				}
			);
		}
	}, [tasks]);
	return <div></div>;
}
